/* Important Info component on the Crew Info Page
   telling users how to registered crew */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";
import { Link } from "react-router-dom" 

const Important = () => {
  return (
    <div className="my-2">
      <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
      <div className={`px-3 py-1 ${styles.SubTitle6}`}>
      <h5 className={`text-center ${styles.Red }`} >IMPORTANT</h5>  
      <hr className={`mt-2 mb-0`}/>
      <p className={`pt-1`}>
        <span className={`${styles.Red}`}>*</span> All Crew Members needed to access the app <span className={`${styles.Red}`}>MUST </span>be 
        registered in the "Manage Users" and added to the Crew Info.
      </p>
      <p className={`pt-2`}>
        <span className={`${styles.Red}`}>*</span> The Crew positions have been divided into Callsheet Main Crew who appear on the Callsheet and 
        Non-Callsheet Extra Crew who don't.
      </p>
      <p className="pt-2" >
      <span className={`${styles.Red}`}>*</span> Add Callsheet Main Crew by clicking the <span className={`${styles.Red}`}>Add Callsheet Main Crew</span> button
      and opening their department.
      </p> 
      <p className="pt-2" >
      <span className={`${styles.Red}`}>*</span> Their Name and Email <span className={`${styles.Red}`}>MUST</span> be inputted in their Department's Crew Position.
      </p>     
      <p className={`pt-2`}>
      <span className={`${styles.Red}`}>*</span> When registering the Crew member their <span className={`${styles.Red}`}>Callname</span>, which 
      displays in their Department Position, must be
      inputted in the Callname field on the form.
      </p>   
      <p className="pt-2" >
        <span className={`${styles.Red}`}>*</span> Add the Non-Callsheet Extra Crew by clicking 
        the <span className={`${styles.Red}`}>Non-Callsheet Extra Dept Positions</span> button 
        at the bottom of each Department page. 
      </p> 
      <p className={` pt-2 pb-1`} >
        <span className={`${styles.Red}`}>*</span> Find info on Replacing, Removing or Rotating Crew and Multiple Directors
        on the Manage Users Info page <Link
      to={`/${localStorage.getItem(
        "projectSlug"
      )}/manageinfo`}
    >here</Link>. 
      </p>  
      <p className={`${styles.Small} pt-3`} >
        <span className={`${styles.Small}`}>Important</span>: If the Production involves Rotating Crew or Multiple Directors be sure to 
        update the Position when a Crew member or Director changes as advised in the above link. 
      </p> 
      <hr className={`mt-2 mb-0`}/>
      </div>
      </Col>
    </Row>
    </div>
  )
}

export default Important